module.exports = __webpack_public_path__ + "static/media/record-4.72bfed9a.png";